import { OnlineOrOffline } from "modules/BookingCommon/common/interfaces"
import { getOnlineAndOfflineService } from "modules/BookingCommon/common/utils/getOnlineAndOfflineService"
import { ServicesGroup } from "utils/helpers/ServicesGroup"

const empty = {
    onlineService: undefined,
    offlineService: undefined,
    onlineAndOfflineAvailable: false,
    offlineHasSlots: false,
    onlineHasSlots: false,
}

export function getService({
    serviceGroup,
    onlineOrOffline,
    unCheckSlots,
}: {
    serviceGroup: ServicesGroup | undefined
    onlineOrOffline: OnlineOrOffline | undefined
    unCheckSlots?: boolean
}) {
    if (!serviceGroup) return empty

    const { onlineService, offlineService } = getOnlineAndOfflineService(serviceGroup, unCheckSlots)

    const offlineHasSlots = onlineOrOffline === "offline" && Boolean(offlineService)
    const onlineHasSlots = onlineOrOffline === "online" && Boolean(onlineService)

    return {
        onlineService,
        offlineService,
        onlineAndOfflineAvailable: Boolean(offlineService && onlineService),
        offlineHasSlots,
        onlineHasSlots,
    }
}
